import { render, staticRenderFns } from "./cv-radio-button.vue?vue&type=template&id=0b6f45f4&"
import script from "./cv-radio-button.vue?vue&type=script&lang=js&"
export * from "./cv-radio-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports